// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__23fMK","loaderOuter":"PageOverlayLoader_loaderOuter__vxdUP"};